var map = {
	"./Thumbs.db": "6ccc",
	"./cmi_logo.png": "b637",
	"./cmi_logo_black.png": "4c30",
	"./favicon.ico": "fbec",
	"./footer/aboutus.jpg": "86f6",
	"./footer/aboutus_e.jpg": "2452",
	"./game/game-v1.jpg": "0e78",
	"./game/gametitle.jpg": "0430",
	"./game/news.jpg": "3ead",
	"./history/game.jpg": "8ea4",
	"./home/arrow_next.png": "9ae5",
	"./home/arrow_prev.png": "520ac",
	"./home/banne01_logo.png": "154d",
	"./home/banne02_logo.png": "dd07",
	"./home/banne03_logo.png": "4b5c",
	"./home/banne04_logo.png": "3b5f",
	"./home/banner001.jpg": "05be",
	"./home/banner002.jpg": "9bf1",
	"./home/banner02.jpg": "faa4",
	"./home/banner03.jpg": "9ebe",
	"./home/game01.jpg": "0523",
	"./home/game02.jpg": "35f3",
	"./home/game03.jpg": "2179",
	"./home/game04.jpg": "a127",
	"./home/sign.png": "a443",
	"./icon-btn-android1.png": "daaa",
	"./icon-btn-android2.png": "cf40",
	"./icon-btn-apk1.png": "ecb4",
	"./icon-btn-apk2.png": "6eb0",
	"./icon-btn-facebook1.png": "4805",
	"./icon-btn-facebook2.png": "c05f",
	"./icon-btn-ios1.png": "185b",
	"./icon-btn-ios2.png": "28ec",
	"./icon_appstore.png": "91c2",
	"./icon_googleplay.png": "a464",
	"./invoice/flow-chart.png": "aa34",
	"./invoice/receipt01.jpg": "3f03",
	"./invoice/receipt02.jpg": "f886",
	"./login-close.png": "d899",
	"./logo/codapay/CODAPAY_logo_A.v2.png": "34d7",
	"./logo/codapay/codapay-smokegrey.png": "ec1c",
	"./member_apple.png": "d545",
	"./member_fb.png": "2143",
	"./member_gg.png": "3e98",
	"./member_gt.png": "63c4",
	"./moregame-close.png": "55b4",
	"./moregame.png": "f529",
	"./nodata.png": "9485",
	"./pad.png": "eb23",
	"./paylogo/ATMICON.png": "e652",
	"./paylogo/PREPAY.png": "8db9",
	"./paylogo/alipay.png": "a66b",
	"./paylogo/creditcard.png": "3f79",
	"./paylogo/default.png": "d76e",
	"./paylogo/esunbank.png": "534b",
	"./paylogo/gashplus.png": "9221",
	"./paylogo/jkopay.png": "9090",
	"./paylogo/linepay.png": "a112",
	"./paylogo/mol.png": "112f",
	"./paylogo/mycard.png": "e723",
	"./paylogo/mycardpay.png": "9329",
	"./paylogo/mycardpoint.png": "c87c",
	"./paylogo/newebpay.png": "bea3",
	"./paylogo/paypal.png": "d524",
	"./paylogo/pepay.png": "0f93",
	"./paylogo/test.png": "bd8e",
	"./paylogo/xsolla.png": "2590",
	"./paylogo/中華電信HINET.png": "f497",
	"./paylogo/中華電信市話.png": "2dfc",
	"./paylogo/中華電信手機.png": "5ca1a",
	"./paylogo/亞太電信.png": "d8ab",
	"./paylogo/八達通.png": "7540",
	"./paylogo/台灣之星.png": "a88a",
	"./paylogo/台灣大哥大(原台灣之星).png": "bab2",
	"./paylogo/台灣大哥大.png": "e6b3",
	"./paylogo/繳費靈.png": "800f",
	"./paylogo/遠傳電信.png": "a87a",
	"./qrcode.png": "a76d",
	"./satisfiedRank1.png": "86bd",
	"./satisfiedRank2.png": "d66a",
	"./satisfiedRank3.png": "73c0",
	"./satisfiedRank4.png": "45be",
	"./satisfiedRank5.png": "6176",
	"./select-down.png": "cdb8",
	"./triangle.png": "c8e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";